import type { BotQuestionnaireAnsweredWebSocket } from "@/Modules/Chat/Models/WebSocket";
import type { EventFilter } from "@/Modules/Chat/WebSocketManager";

import { MessageTypeWebSocket } from "@/Modules/Chat/Models/WebSocket";
import { useQuestionnaireStore, type QuestionnaireStore } from "@/Modules/Questionnaire/Store";
import { useUserStore, type UserStore } from "@/Modules/User/Store";

import { isObject } from "@/Utils/Objects";

export interface ExtraParamsQuestionnaireAnswered {
  questionnaireStore: QuestionnaireStore;
  userStore: UserStore;
}

export const isQuestionnaireAnsweredType = (value: unknown): value is BotQuestionnaireAnsweredWebSocket => {
  return (
    isObject(value) && value.type === MessageTypeWebSocket.QUESTIONNAIRE_ANSWERED && isObject(value.data)
  );
};

export const questionnaireAnsweredHandler = async (
  message: BotQuestionnaireAnsweredWebSocket,
  {
    questionnaireStore = useQuestionnaireStore(),
    userStore = useUserStore(),
  }: ExtraParamsQuestionnaireAnswered
): Promise<undefined> => {
  if (isDeleteQuestionnaire(questionnaireStore, message.data.questionnaire_uuid)) {
    await userStore.deleteAccount();

    return Promise.resolve(undefined);
  }

  questionnaireStore.fetchQuestionnaireSummaries();

  return Promise.resolve(undefined);
};

const isDeleteQuestionnaire = (
  questionnaireStore: QuestionnaireStore,
  questionnaireUuid: string
): boolean => {
  return questionnaireStore.getDeleteFormId === questionnaireUuid;
};

export default {
  isType: isQuestionnaireAnsweredType,
  handler: questionnaireAnsweredHandler,
} as EventFilter<ExtraParamsQuestionnaireAnswered>;
